<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head"></div>
          <div class="modal-con">
            <div class="modal-txt">
              <p>
                최신 업데이트 버전이 있습니다.<br />
                업데이트 하시겠습니까?
              </p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn medium border-gray" @click="close">나중에</button>
              <button class="btn primary medium" @click="fnMove">업데이트</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { nativeLink } from '@/common/utils/module/NativeRequest';
import store from '@/store';
const props = defineProps(['data']);
const emits = defineEmits(['close']);
const fnMove = () => {
  const device = store.getters['user/getDeviceInfo'];
  if (device.deviceType === 'ANDROID') {
    nativeLink('https://play.google.com/store/apps/details?id=com.appg.jump');
  } else {
    nativeLink(
      'https://apps.apple.com/us/app/%EB%9D%BC%EC%9D%B4%ED%94%84%EC%95%A4%EB%93%9C%EB%9D%BC%EC%9D%B4%ED%94%84-%EA%B8%B0%EB%8F%85%EA%B5%90%EB%B6%80%EA%B3%A0%EC%9E%A5-%EC%B2%AD%EC%A0%91%EC%9E%A5-%EC%B6%94%EB%AA%A8%EA%B4%80-%EB%AA%A8%EB%B0%94%EC%9D%BC%EA%B2%BD%EC%A1%B0%EC%82%AC/id6670776419'
    );
  }
  close();
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>
